<template>
  <div>

    <div class="row mt-20" v-if="preconization">
      <div class="col-xs-12">
        <!-- BEGIN VALIDATION STATES-->
        <form id="newAction" class="form-horizontal col-xs-12 absolute-parlsey-errors">
          <div class="portlet light portlet-fit portlet-form bordered col-xs-12 p-0 ">
              <div class="portlet-title col-xs-12 ">
                  <div class="caption">
                    <i class=" icon-plus font-green"></i>
                    <span class="caption-subject sbold uppercase font-green">Nouvelle préconisation </span>
                  </div>
              </div>

              <div class="portlet-body col-xs-12 text-right">

                <div class="col-xs-12 form-group form-md-line-input">
                    <label class="col-md-3 control-label">N°
                        <!-- <span class="required" aria-required="true">*</span> -->
                    </label>
                    <div class="col-lg-6 col-md-9">
                        <input type="number" min="1" class="form-control" disabled v-model="preconization.number">
                        <div class="form-control-focus"> </div>
                    </div>
                </div>

                <div class="col-xs-12 form-group form-md-line-input">
                    <label class="col-md-3 control-label">Titre
                        <span class="required" aria-required="true">*</span>
                    </label>
                    <div class="col-lg-6 col-md-9">
                        <input type="text" class="form-control" placeholder="" v-model="preconization.title" required>
                        <div class="form-control-focus"> </div>
                    </div>
                </div>

                <div class="col-xs-12 form-group form-md-line-input">
                    <label class="col-md-3 control-label">Description
                        <!-- <span class="required" aria-required="true">*</span> -->
                    </label>
                    <div class="col-lg-6 col-md-9">
                        <textarea type="text" placeholder="" rows="3" class="form-control"  style="padding:10px"  v-model="preconization.description"></textarea>
                        <div class="form-control-focus"> </div>
                    </div>
                </div>

                <div class="mt-element-ribbon col-xs-12" v-for="(action,action_index) in preconization.actions">
                  <hr style="width:80%;margin:auto;border-style:dashed;position:relative;top:30px;border-color:gray;">

                  <div class="ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase">
                    <div class="ribbon-sub ribbon-clip"></div> Action n°{{action.number}}
                  </div>

                  <a class="text-danger bt-remove" style="white-space: nowrap;" v-on:click="removeAction(action_index)">
                    <span aria-hidden="true" class="icon-close"></span> Supprimer
                  </a>

                  <br><br>

                  <div class="col-xs-12 form-group form-md-line-input">
                      <label class="col-md-3 control-label">Titre
                          <span class="required" aria-required="true">*</span>
                      </label>
                      <div class="col-lg-6 col-md-9">
                          <input type="text" class="form-control" placeholder="" v-model="action.title" required>
                          <div class="form-control-focus"> </div>
                      </div>
                  </div>

                  <div class="col-xs-12 form-group form-md-line-input">
                      <label class="col-md-3 control-label">Description
                          <!-- <span class="required" aria-required="true">*</span> -->
                      </label>
                      <div class="col-lg-6 col-md-9">
                        <textarea type="text" placeholder="" rows="3" class="form-control"  style="padding:10px"  v-model="action.description"></textarea>
                        <div class="form-control-focus"> </div>
                      </div>
                  </div>

                  <div class="col-xs-12 form-group form-md-line-input">
                      <label class="col-md-3 control-label">Délai de réalisation
                          <!-- <span class="required" aria-required="true">*</span> -->
                      </label>
                      <div class="col-lg-6 col-md-9">
                          <input type="text" class="form-control" placeholder="" v-model="action.deadline"  >
                          <div class="form-control-focus"> </div>
                      </div>
                  </div>

                </div>

                <div class="col-xs-12 text-right">
                  <a style="white-space: nowrap;" v-on:click="addAction()"><span aria-hidden="true" class="icon-plus"></span> Ajouter une action</a>
                </div>


                <div class="col-xs-12 mt-10">
                  <div class="form-actions col-xs-12">
                    <div class="row">
                      <div class="text-left" style="float:left;">
                        <a class="btn default" v-on:click="$router.back()">Annuler</a>
                      </div>
                      <div class="text-right">
                        <a class="btn green" v-on:click="savePreconization()">Enregistrer</a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
          </div>
        </form>
        <!-- END VALIDATION STATES-->
      </div>
    </div>
    <div class="row m-0" v-else>
      <div class="col-md-12 page-404 mt-50 pb-50">
          <div class="number font-green"> 404 </div>
          <div class="details">
              <h3>Oops ! Préconisation non trouvée.</h3>
              <p> Nous n'avons pas réussi à trouver cette préconisation.
                  <br>
                  Vérifiez'url et tentez de recharger la page.
              </p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

  import quizzes from '../../../requests/quizzes.js'

  export default {
    created () {
    },
    props: [""],
    data(){
      return{
        preconization:{
          number:1,
          title:"",
          description:"",
          actions:[
            {
              number:1.1,
              title:"",
              description:"",
              deadline:""
            }
          ]
        }
      }
    },
    mounted:function(){
      var parent = this;
      if(this.$route.params.id){
        // Edition préco.
        quizzes.getPreconizationById(this,this.$route.params.slug,this.$route.params.id,function(preconization,err){
          if(preconization){
            parent.preconization = preconization;
          }
          else{
            parent.preconization = null;
            toastr.error("Impossible de récupérer cette préconisation.","ERREUR");
          }
        })
      }
      else{
        // Creation nouvelle préco.
        quizzes.getPreconizations(this,this.$route.params.slug,function(preconizations,err){
          if(preconizations){
            // Déterminer automatiquement le n° de la préconisation.
            // Attention si le number est modifiable. Alors l'automatisation risque de merder si le mec ne saisie pas dans l'ordre.
            if(preconizations.length > 0){
              parent.preconization.number = preconizations[preconizations.length-1].number+1;
              parent.preconization.actions[0].number = parent.preconization.number +".1";
            }
          }
          else{
            toastr.warning("Impossible de calculer le numéro de cette nouvelle préconisation.","Attention");
          }
        })
      }
    },
    methods:{
      addAction(){
        var num = this.preconization.number;
        num += "."+(this.preconization.actions.length+1);
        num = parseFloat(num);
        this.preconization.actions.push({
          number:num,
          title:"",
          description:"",
          deadline:""
        })
      },
      removeAction(index){
        this.preconization.actions.splice(index,1);
        // MAJ tous les n° des actions.
        for(var a=0;a<this.preconization.actions.length;a++){
          var num = this.preconization.number;
          num += "."+ (a+1)
          num = parseFloat(num);
          this.preconization.actions[a].number = num;
        }
      },
      savePreconization(){
        $('#newAction').parsley().validate()
        if($("#newAction").parsley().isValid()){
          if(this.$route.params.id){
            this.updatePreconization();
          }
          else{
            this.createPreconization();
          }
        }
      },
      createPreconization(){
        var parent = this;
        quizzes.createPreconization(this,this.$route.params.slug,this.preconization,function(preconization,err){
          if(preconization){
            toastr.success("La nouvelle préconisation a bien été créée.");
            parent.$router.push({name:'quizzes_preconizations'});
          }
          else{
            toastr.error(err,"ERREUR");
          }
        })
      },
      updatePreconization(){
        var parent = this;
        quizzes.updatePreconizationById(this,this.$route.params.slug,this.$route.params.id,this.preconization,function(preconization,err){
          if(preconization){
            toastr.success("La préconisation a bien été enregistrée.");
            parent.$router.push({name:'quizzes_preconizations'});
          }
          else{
            toastr.error(err,"ERREUR");
          }
        })
      }
    }
  }
</script>

<style scoped>
  .ribbon{
    left:-20px!important;
  }

  .bt-remove{
    display: block;
    margin-top: 20px;
    text-align: right;
    float:right;
  }
</style>



// WEBPACK FOOTER //
// new_action.vue?af61ad12